import React from "react";
import { Container } from "react-bootstrap";

export default function Footer(props:any) {
    return <Container className="storehome-footer">
        <div style={{paddingLeft:"15px"}}>
        COPYRIGHT © 2023 ${props.store?.store_name} LLC. ALL RIGHTS RESERVED
        </div>
    </Container>
}